module.exports = fox => {
    'use strict';

    fox.registerWidget('Base_Payment_Form', {
        configure: function() {
            this.registerOptions('', {
                autoRender: true,
                // manualRender: true,
                'embed.container': '#payment-form-container',
                widgets: {
                    form: {
                        widget: 'DomForm',
                        formSelector: '#payment-form',
                    }
                }
            });
            
            this.callParent('configure', arguments);
        },

        init() {
            this.data = {};
            this._editable = false;
            this._bindData = {
                paymentEmail: '',
                minPayout: '',
            };

            this.bindTemplateVariables(this._bindData, ['paymentEmail', 'minPayout']);

            this.callParent('init', arguments);
        },

        running() {
            this.form = this.wom1('#form');

            this.callParent('running', arguments);
        },

        activate() {
            // this.setTemplateOptions({editable: this.editable()});

            // if (!fox.isEmpty(this.data)) {
            //     this._bindData.paymentEmail = this.data.paymentEmail;
            //     this._bindData.minPayout = this.data.minPayout;
            // }
            this.switchFormState();

            this.callParent('activate', arguments);
        },

        setData(data) {
            this.data = data;
        },

        editable(state) {
            if (fox.isSet(state)) {
                this._editable = state;
            }

            return this._editable;
        },

        switchToEditableForm() {
            this.editable(true);
            this.setTemplateOptions({editable: this.editable()});

            this.render();

            this.wait(this, 'addedToDom', {prefix: `${this.getAlias()}_addedToDom`})
                .then(() => {
                    this.form.setValues(this.data);
                });
        },

        switchToValues() {
            this.editable(false);
            this.setTemplateOptions({editable: this.editable()});
            this._bindData.paymentEmail = this.data.paymentEmail;
            this._bindData.minPayout = this.data.minPayout;

            this.render();
        },

        switchFormState() {
            if (this.editable()) {
                this.switchToEditableForm()
            } else {
                this.switchToValues();
            }
        },

        getValues() {
            return this.form.getValues();
        },

        validate() {
            return this.form.validate();
        }
    }, 'Widget');
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/account/forms/base.es.js